import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getIndustryDrawerData } from 'services/app';

export default function useIndustryDrawerData(
  industrySlug: string,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    `industry-${industrySlug}-drawer-data`,
    () =>
      getIndustryDrawerData(industrySlug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
    }
  );
}
